// =============================================================================
// Superadmin Layout - Layout dédié pour l'espace Superadmin
// Complètement séparé de la plateforme principale
// =============================================================================

import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { checkIsSuperadmin } from '@/modules/core/data/superadminRepository';
import { useAuth } from '@/contexts/AuthContext';
import { SuperadminSidebar } from './SuperadminSidebar';
import { Skeleton } from '@/components/ui/skeleton';
import { Shield } from 'lucide-react';
import { AccessDeniedDialog } from '@/components/shared/AccessDeniedDialog';

export function SuperadminLayout() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [isSuperadmin, setIsSuperadmin] = useState(false);
  const [accessDenied, setAccessDenied] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  useEffect(() => {
    checkAccess();
  }, [user, authLoading]);

  const checkAccess = async () => {
    if (authLoading) return;

    if (!user) {
      navigate('/auth');
      return;
    }

    try {
      const result = await checkIsSuperadmin();
      if (!result) {
        setIsSuperadmin(false);
        setAccessDenied(true);
      } else {
        setIsSuperadmin(true);
      }
    } catch (err) {
      console.error('Error checking superadmin:', err);
      setIsSuperadmin(false);
      setAccessDenied(true);
    } finally {
      setChecking(false);
    }
  };

  if (authLoading || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#0F172A' }}>
        <div className="text-center space-y-4">
          <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center mx-auto animate-pulse">
            <Shield className="h-8 w-8 text-white" />
          </div>
          <Skeleton className="h-4 w-32 mx-auto bg-slate-700" />
        </div>
      </div>
    );
  }

  if (!isSuperadmin) {
    return <AccessDeniedDialog open={accessDenied} onOpenChange={(nextOpen) => { if (!nextOpen) setAccessDenied(false); }} />;
  }

  return (
    <div className="min-h-screen flex w-full" style={{ backgroundColor: '#0F172A' }}>
      <SuperadminSidebar 
        collapsed={sidebarCollapsed} 
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)} 
      />
      <main className="flex-1 overflow-auto" style={{ backgroundColor: '#1E293B' }}>
        <Outlet />
      </main>
    </div>
  );
}
